import { render, staticRenderFns } from "./HintsComponent.vue?vue&type=template&id=24ff89ee&scoped=true"
import script from "./HintsComponent.vue?vue&type=script&lang=js"
export * from "./HintsComponent.vue?vue&type=script&lang=js"
import style0 from "./HintsComponent.vue?vue&type=style&index=0&id=24ff89ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ff89ee",
  null
  
)

export default component.exports